// @flow
import React, { useContext } from 'react';
import { Grid } from 'semantic-ui-react';
import { getIfCurrentVBDConflictsWithAnyMLD } from '@src/configuration/custom-discounts';

import { getIfRowIsVBD } from '../../../components/custom-discounts/utils';
import { VBDConflictingRowMessageContainer } from '../../../components/common/vbd/VBDConflictingRowMessageContainer';
import {
  FieldArrayGridConfigItemContext,
  FieldArrayStyledGridRow,
} from '../../../formik-utils/FieldArrayGrid';
import { MLDVBDAndUserStatusTagContainer } from '../MLDVBDAndUserStatusTagContainer';

import { DependentDimensionsDropdownContainer } from './DependentDimensionsDropdownContainer';
import { DimensionsConfigUpdateButtonContainer } from './DimensionsConfigUpdateButtonContainer';
import { DimensionsConfigDeleteButtonContainer } from './DimensionsConfigDeleteButtonContainer';

export const MetricsLevelDiscountsDimensionsConfigurationItem = () => {
  const { parentContext, rowValues } = useContext(FieldArrayGridConfigItemContext);
  const isVBDRow = getIfRowIsVBD(rowValues);
  const completeDimensionsArray = parentContext?.dimensions_config_array ?? [];
  const { doesVBDRowConflictWithAnyOtherUserRow } = getIfCurrentVBDConflictsWithAnyMLD(
    completeDimensionsArray,
    rowValues,
    isVBDRow
  );

  return (
    <>
      <FieldArrayStyledGridRow>
        <MLDVBDAndUserStatusTagContainer
          doesVBDRowConflictWithAnyOtherUserRow={doesVBDRowConflictWithAnyOtherUserRow}
          isVBDRow={isVBDRow}
          rowValues={rowValues}
        />
        <DependentDimensionsDropdownContainer />
        <Grid.Column width={1}>
          <DimensionsConfigUpdateButtonContainer />
        </Grid.Column>
        <Grid.Column width={1}>
          <DimensionsConfigDeleteButtonContainer />
        </Grid.Column>
      </FieldArrayStyledGridRow>
      <VBDConflictingRowMessageContainer
        doesVBDRowConflictWithAnyOtherUserRow={doesVBDRowConflictWithAnyOtherUserRow}
        isVBDRow={isVBDRow}
      />
    </>
  );
};
